import { Injectable, TemplateRef } from '@angular/core';
import { UserActionProcess } from 'src/app/model/asd/asd-properties/asd-userActionProcess';
import { InterfaceElement, IEUserAction, IEEntityList } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { FormInterfaceCommunicatorProperty } from 'src/app/model/form/form-properties/form-interfaceCommunicatorProperty';
import { CosyAppStateDataControllerService } from './cosy-app-state-data-controller.service';
import { AsdBase } from 'src/app/model/asd/asd';
import { FormBase } from 'src/app/model/form/form';
import { FormGroup, AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormInit } from 'src/app/model/form/form-properties/form-init';
import { HTMLBase } from 'src/app/model/html/html';
import { Message } from 'src/app/model/asd/asd-properties/asd-message';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { ViewArea } from 'src/app/model/asd/asd-properties/asd-viewArea';
import { CosyCommunicationControllerService, SearchOption } from './cosy-communication-controller.service';
import { InterfaceElementViewAreaTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-viewAreaType';
import { ASDTypes } from 'src/app/model/asd/asd-properties/asd-type';
import { FormMessage } from 'src/app/model/form/form-properties/form-message';
import { Transition, FormTransition } from 'src/app/model/form/form-properties/form-transition';
import { UserActionIdentifiers } from 'src/app/model/user/user-properties/user-actionIdentifier';
import { element } from 'protractor';
import { LocaleTypes } from 'src/app/model/locale/locale-type';
import { InterfaceElementTemplate } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-template';
import { User } from 'src/app/model/user/user';
import { HeaderItem } from 'src/app/model/asd/asd-properties/asd-ie-type/asd-list';
import { Attribute } from 'src/app/model/asd/asd-properties/asd-attribute';

@Injectable({
  providedIn: 'root'
})
export class UXControllerService {
  public appName: string = '';
  public appSessionID: string = '';
  private _ASD: AsdBase;
  public appStateID: string = '';
  public appStateName: string = '';
  public primaryEntityID: string = '';

  private formGroup: FormGroup = null;
  public ieEntityList: InterfaceElement;
  public ieEntity: InterfaceElement;
  public ieMenuList: InterfaceElement;
  public ieWizard: InterfaceElement;
  public ieUX: InterfaceElement;
  public ieRibbon: InterfaceElement;
  public ieSearch: InterfaceElement;
  public activeSelectedRow: number[] = [];
  public activeSelectedRowID: string[] = [];
  public activeSelectedRowDisplayName: string[] = [];

  public cosyToken: string = null;
  public sessionID: string = "91242d63-6822-47f7-a9dc-628e0e89db80";

  public lastUXControllerUA: string = null;
  public cosyFormInitProperties: FormInit = new FormInit();
  private payloadFromAPI: AsdBase;
  private payloadToAPI: AsdBase = new AsdBase();
  private payLoadInterfaceElements: InterfaceElement[] = [];
  private icProps: FormInterfaceCommunicatorProperty;
  private uxControllerProps = new FormBase();
  private dutyComplete: boolean = false;
  private dutyCompleteNew: boolean = false;
  private uxControllerInterfaceElementID: string
  public isMenuClick: boolean = false;
  public isAPOS: boolean = false;
  public isDynaFunctionCompleted: boolean = false;
  public dynaReferenceIEID: string;
  public autoGridRowHeight: number = 0;
  public autoRowNumber: number = 0;
  public currentBreadCrumbTitle: string = '';
  public loginUserModel: User;
  public appSwitchedUser: User = new User();

  //RTKeys
  public RTKeyAllowDynaEdit: boolean = false;
  public RTKeyShowNullable: boolean = false;
  public isAdmin: boolean = false;
  public ActivePrimaryGroup: string;
  public AppServerOwner: string = "";

  //Pdf
  public zoom: string = 'auto';
  public rotation: number = 0;
  public page: number = 0;
  public documentPdfBase64: string = '';
  public documentID: string = '';


  executeUA: Subject<UserActionProcess> = new Subject<UserActionProcess>();
  executeDCUC: Subject<boolean> = new Subject<boolean>();
  executeTreeUA: Subject<{ ua: string, value: string }> = new Subject<{ ua: string, value: string }>();
  executeCollTreeSearch: Subject<SearchOption> = new Subject<SearchOption>();
  showMessage: Subject<Message> = new Subject<Message>();
  showDynaEditor: Subject<any> = new Subject<any>();
  showAccessRightEditor: Subject<any> = new Subject<any>();
  showCollection: Subject<any> = new Subject<any>();

  constructor(
    private cosyAppStateDataControllerService: CosyAppStateDataControllerService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService
  ) {
  }

  public get ASD(): AsdBase {
    return this._ASD;
  }

  public set ASD(value: AsdBase) {
    this._ASD = value;
    this.primaryEntityID = this._ASD.Header.PrimaryEntityID;
    let va4: ViewArea = this._ASD.ViewAreas.find(viewArea => viewArea.ViewAreaTypeDID == InterfaceElementViewAreaTypes.ViewArea4Type);
    let va2: ViewArea = this._ASD.ViewAreas.find(viewArea => viewArea.ViewAreaTypeDID == InterfaceElementViewAreaTypes.ViewArea2Type);
    if (va2 != null) {
      this.ieMenuList = va2.InterfaceElements.filter(ie => ie.TypeDID == InterfaceElementTypes.MenuList)[0];
      this.appStateName = this.ieMenuList.ObjectName;
    }
    if (va4 != null && this._ASD.Header.ViewTypeDID == ASDTypes.ListViewTypeDID) {
      this.ieEntityList = va4.InterfaceElements.filter(ie => ie.TypeDID == InterfaceElementTypes.EntityList)[0];
      this.ieRibbon = va4.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Ribbon);
      if (this.ieRibbon != null) this.ieSearch = this.ieRibbon.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.InputSearch);
      if (this.ieRibbon != null) this.ieUX = this.ieRibbon.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.ListUXController);
    }
    if (va4 != null && this._ASD.Header.ViewTypeDID == ASDTypes.EntityViewTypeDID) {
      this.ieEntity = va4.InterfaceElements.filter(ie => ie.TypeDID == InterfaceElementTypes.FormEntity)[0];
      this.ieRibbon = va4.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Ribbon);
      if (this.ieRibbon != null) this.ieSearch = this.ieRibbon.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.InputSearch);
      if (this.ieRibbon != null) this.ieUX = this.ieRibbon.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.UXController);
    }
    if (va4 != null && this._ASD.Header.ViewTypeDID == ASDTypes.WizardViewTypeDID) {
      this.ieWizard = va4.InterfaceElements.filter(ie => ie.TypeDID == InterfaceElementTypes.Wizard)[0];
      this.ieRibbon = va4.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Ribbon);
      if (this.ieRibbon != null) this.ieUX = this.ieRibbon.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.UXController);
    }
    if (this._ASD.Header.AppStateID != this.appStateID) {
      this.dutyComplete = false;
      this.dutyCompleteNew = false;
      this.appStateID = this._ASD.Header.AppStateID;
    }
  }

  public setActiveSelectedRows(selectedRow: number[], selectedRowID: string[], selectedRowDisplayName: string[]) {
    this.activeSelectedRow = selectedRow;
    this.activeSelectedRowID = selectedRowID;
    this.activeSelectedRowDisplayName = selectedRowDisplayName;
  }

  openDynaEditor(ie: InterfaceElement, template: TemplateRef<any>) {
    this.isDynaFunctionCompleted = false;
    this.dynaReferenceIEID = ie.InterfaceElementID;
    this.showDynaEditor.next({ "ie": ie, "template": template });
  }

  openAccessRightEditor(ie, InterfaceElement, template: TemplateRef<any>) {
    this.showAccessRightEditor.next({ "ie": ie, "template": template });
  }
  fetchTreeUserAction(ua: string, value: string): void {
    this.executeTreeUA.next({ ua, value });
  }

  fetchCollTreeSearch(so: SearchOption): void {
    this.executeCollTreeSearch.next(so);
  }

  fetchColletion(): void {
    this.showCollection.next();
  }

  fetchUXUserAction(userActionID: string, interfaceElementID: string, value: any): void {
    this.lastUXControllerUA = userActionID;
    let fetchedUserActionInfo = new UserActionProcess();
    fetchedUserActionInfo.UserActionID = userActionID;
    fetchedUserActionInfo.InterfaceElementID = interfaceElementID;
    fetchedUserActionInfo.Value = value;
    fetchedUserActionInfo.ProcessActionOnServer = true;
    this.executeUA.next(fetchedUserActionInfo);
    if (userActionID != this.cosyFormInitProperties.UXControllerProperties.FormInvalidUAID && userActionID != this.cosyFormInitProperties.UXControllerProperties.FormValidUAID) {
      this.dutyComplete = false;
      this.dutyCompleteNew = false;
    }
  }

  fetchIEUserAction(userActionID: string, ie: InterfaceElement, value: any, attributeKey: string, additionalAttributes: any[], additionalInterfaceElements: InterfaceElement[], group: FormGroup, multiSelect: boolean): void {
    this.fetchUserAction(userActionID, ie, null, value, attributeKey, additionalAttributes, additionalInterfaceElements, group, multiSelect)
  }

  fetchUserAction(userActionID: string,
    ie: InterfaceElement,
    ieHTML: HTMLBase,
    value: any,
    attributeKey: string,
    additionalAttributes: any[],
    additionalInterfaceElements: InterfaceElement[],
    group: FormGroup,
    multiSelect: boolean): void {
    let processActionOnServer: boolean = false;
    let icProps: FormInterfaceCommunicatorProperty;
    let fetchedUserActionInfo = new UserActionProcess();
    let controllName: string[] = [];
    let userActions: IEUserAction[];
    let interfaceElementID: string;
    if (ie != null) {
      userActions = ie.UserActions;

      interfaceElementID = ie.InterfaceElementID;
    }

    if (userActionID == 'dededede-55fa-4b61-b4a0-92c8074fb627') {
      this.fetchTreeUserAction(userActionID, value);
    }
    if (userActionID == 'c6b552a4-a6ee-4f48-b91c-683dc43a3f61') {
      this.showCollection.next();
    }
    if (userActionID != null) {
      processActionOnServer = this.cosyAppStateDataControllerService.isActionProcessOnServer(userActionID, userActions);
      icProps = this.processUXUserAction(userActionID, this.cosyFormInitProperties.UXControllerProperties, null, null, null, processActionOnServer, null); //this.formControlInterfaceElement);
      this.cosyFormInitProperties.UXControllerProperties.FormCurrentState = icProps.TransitStateID;
      this.cosyFormInitProperties.UXControllerProperties.FormCurrentUserActionID = userActionID;

      fetchedUserActionInfo.UserActionID = userActionID;
      fetchedUserActionInfo.InterfaceElementID = interfaceElementID;
      fetchedUserActionInfo.Value = value;
      fetchedUserActionInfo.AttributeKey = attributeKey;
      fetchedUserActionInfo.AdditionalAttributes = additionalAttributes;
      fetchedUserActionInfo.AdditionaInterfaceElements = additionalInterfaceElements;
      fetchedUserActionInfo.MultiSelect = multiSelect;
      fetchedUserActionInfo.ProcessActionOnServer = processActionOnServer;
      this.executeUA.next(fetchedUserActionInfo);
      if (group != null) Object.keys(group.controls).forEach((key: string) => { if (group.contains(key)) controllName.push(key) });
      if (this.formGroup == null || group == null || !this.formGroup.contains(controllName[0])) {
        this.dutyComplete = false;
        this.dutyCompleteNew = false;
        this.formGroup = group;
      }
      if (group != null) {
        if (this.lastUXControllerUA == null) this.lastUXControllerUA = userActionID;
        this.dutyCompleteNew = this.onEditDutyTest(group, this.lastUXControllerUA);
      }
      if (this.dutyCompleteNew != this.dutyComplete) {
        this.executeDCUC.next(this.dutyCompleteNew);
        this.dutyComplete = this.dutyCompleteNew;
      }

    }
  }

  /*Verify AppStateDocument has Form Controls*/
  verifyASDwithUX(asd: AsdBase) {
    let uxControllerMatrixID = null;
    let matched: boolean = false;
    for (let va of asd.ViewAreas) {
      for (let ie of va.InterfaceElements) {
        if(ie.TypeDID == InterfaceElementTypes.Ribbon){
          for(let iee of ie.InterfaceElements){
            if (iee.TypeDID == InterfaceElementTypes.UXController || iee.TypeDID == InterfaceElementTypes.ListUXController) {
              uxControllerMatrixID = iee.Attributes.FormControllerMatrixID;
              this.uxControllerInterfaceElementID = iee.InterfaceElementID;
              matched = true;
              break;
            }
          }
        }
        if (ie.TypeDID === InterfaceElementTypes.UXController || ie.TypeDID == InterfaceElementTypes.ListUXController) {
          uxControllerMatrixID = ie.Attributes.FormControllerMatrixID;
          this.uxControllerInterfaceElementID = ie.InterfaceElementID;
          matched = true;
          break;
        }
      }
      if (matched) {
        break;
      }
    }
    return uxControllerMatrixID;
  }

  onEditDutyTest(currentCosyForm, userActionID) {
    let dutyComplete: boolean = false;
    if (currentCosyForm != null && userActionID !== null) {
      if (!currentCosyForm.invalid) {
        dutyComplete = true;
      } else if (currentCosyForm.invalid) {
        dutyComplete = false;
      }
    }
    this.dutyCompleteNew = dutyComplete;
    if ((this.dutyCompleteNew != this.dutyComplete) && userActionID == 'init') {
      this.executeDCUC.next(this.dutyCompleteNew);
      this.dutyComplete = this.dutyCompleteNew;
    }
    return dutyComplete;
  }

  //
  processUXUserAction(
    userActionID: string,
    uxControllerProps: FormBase,
    interfaceCommunicatorProps: FormInterfaceCommunicatorProperty,
    callFromMessage: boolean,
    optionID: string,
    processOnServer: boolean,
    formControlInterfaceElementID: string
  ) {
    let icProps: FormInterfaceCommunicatorProperty;
    let message = new FormMessage();
    let transition = new Transition();
    let oldState: string;
    let options = [];

    if (formControlInterfaceElementID == null) formControlInterfaceElementID = this.uxControllerInterfaceElementID;

    oldState = uxControllerProps.FormCurrentState;
    transition = this.getFormTransitionProperty(uxControllerProps.FormCurrentState, userActionID, uxControllerProps.FormTransitions);
    if (transition.userActionID == null) {
      transition.transitStateID = oldState;
      transition.userActionID = userActionID;
      transition.actionProcessOnServer = processOnServer;
    }
    if (userActionID == uxControllerProps.FormValidUAID || userActionID == uxControllerProps.FormInvalidUAID) {
      transition = transition;
    } else {
      if (transition.actionProcessOnServer && transition.message == null) {
        transition.transitStateID = oldState;
      } else if (transition.actionProcessOnServer && transition.message != null) {
        transition.transitStateID = oldState;
        transition.actionProcessOnServer = false;
      } else if (!transition.actionProcessOnServer && transition.message == null) {
        if (Object.keys(transition).length === 0) {
          transition.transitStateID = oldState;
        }
        transition = transition;
      } else if (!transition.actionProcessOnServer && transition.message != null) {
        transition.currentStateID = transition.transitStateID;
        transition.transitStateID = oldState;
      }
    }
    if (interfaceCommunicatorProps != null) {
      message = interfaceCommunicatorProps.message;
      options = interfaceCommunicatorProps.options;
    } else {
      if (transition.message != null) {
        message = this.getFormMessage(transition.message.messageID, uxControllerProps.FormMessages);
        if (transition.message.options != null) {
          options = transition.message.options;
          for (let o of options) {
            this.cosyCommunicationControllerService.getGetTextShort(this.sessionID, o.optionID).subscribe(
              did => {
                o.option = did["value"];
              }
            );
            if (o.TransitUserActionID == null || o.TransitUserActionID == '') {
              o.TransitUserActionID = transition.userActionID;
            }
          }
        }

        if (callFromMessage) {
          let apos: boolean = false;
          for (let o of options) {
            if (o.TransitUserActionID == transition.userActionID && optionID == o.optionID) {
              transition.actionProcessOnServer = o.actionProcessOnServer;
              transition.transitStateID = transition.currentStateID;
            }
          }
        }
      }
    }

    icProps = new FormInterfaceCommunicatorProperty(transition.transitStateID, message, options, userActionID, transition.actionProcessOnServer, oldState);

    if (!icProps.ProcessRequiredOnServer && icProps.OldStateID !== icProps.TransitStateID) {
      console.log('Old State: ', icProps.OldStateID);
      console.log('New State: ', icProps.TransitStateID);
      this.cosyCommunicationControllerService.postServerStateChangeOnServer(
        UserActionIdentifiers.LoginSessionID,
        formControlInterfaceElementID,
        icProps.TransitStateID)
    }
    console.log('New State always: ', icProps.TransitStateID);
    return icProps;
  }

  getFormTransitionProperty(stateID, actionKey, formTransitions: FormTransition[]) {
    let transition = new Transition();
    if (formTransitions != null && formTransitions.length > 0) {
      for (let ft of formTransitions) {
        if (stateID === ft.stateID) {
          for (let tp of ft.transitions) {
            if (actionKey === tp.userActionID) {
              transition = tp;
            }
          }
        }
      }
    }
    return transition;
  }

  getFormMessage(messageId, formMessages: FormMessage[]) {
    let message = new FormMessage();
    for (let msg of formMessages) {
      if (messageId === msg.messageID) {
        message = Object.assign(new FormMessage(), msg);
        break;
      }
    }
    return message;
  }

  getControlName(c: AbstractControl): string | null {
    const formGroup = c.parent.controls;
    return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
  }

  getIEformEntity(ieID: string): InterfaceElement | null {
    return this.ieEntity.InterfaceElements.find(element => element.InterfaceElementID == ieID) || null;
  }

  public setRuntimeKeys(sessionID: string) {
    this.cosyCommunicationControllerService.getRuntimeKey(sessionID, "AllowDynaEdit").subscribe(
      key => {
        this.RTKeyAllowDynaEdit = JSON.parse(key["value"]);
        if (this.ActivePrimaryGroup == '67faa3df-1743-4368-b905-58a433ce1693') this.RTKeyAllowDynaEdit = true;
        else this.cosyCommunicationControllerService.RTKeyAllowDynaEdit = this.RTKeyAllowDynaEdit;
      },
      error => {
        this.RTKeyAllowDynaEdit = false,
          this.cosyCommunicationControllerService.RTKeyAllowDynaEdit = this.RTKeyAllowDynaEdit
      });
    this.cosyCommunicationControllerService.getRuntimeKey(sessionID, "ShowNullable").subscribe(
      key => {
        this.RTKeyShowNullable = JSON.parse(key["value"]),
          this.cosyCommunicationControllerService.RTKeyShowNullable = this.RTKeyShowNullable
      },
      error => {
        this.RTKeyShowNullable = true,
          this.cosyCommunicationControllerService.RTKeyShowNullable = this.RTKeyShowNullable
      });
  }

  senseLanguageCode(trigger: InterfaceElement) {

    if (this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeDE_CODE
      && (trigger.TemplateID == InterfaceElementTemplate.LanguageDETriggerLVTemplate
        || trigger.TemplateID == InterfaceElementTemplate.LanguageDETriggerEVTemplate
        || trigger.TemplateID == InterfaceElementTemplate.LanguageDETriggerWizardTemplate)) { trigger.Attributes.Enabled = false; }
    else if (this.cosyCommunicationControllerService.locale == LocaleTypes.LocaleTypeEN_CODE
      && (trigger.TemplateID == InterfaceElementTemplate.LanguageENTriggerLVTemplate
        || trigger.TemplateID == InterfaceElementTemplate.LanguageENTriggerEVTemplate
        || trigger.TemplateID == InterfaceElementTemplate.LanguageENTriggerWizardTemplate)) { trigger.Attributes.Enabled = false; }

    return trigger;
  }

  calculateAutoGridRowNumber(innerHeight: number, rowHeight: number){ 
    var rowsHeight= 0;
    var calcRowNumbers = 0;
    this.autoRowNumber = 0;
    while(rowsHeight <= innerHeight){
      rowsHeight = rowsHeight + rowHeight;
      calcRowNumbers = calcRowNumbers + 1;
      this.autoRowNumber = this.autoRowNumber +1;
    }
    this.autoRowNumber = this.autoRowNumber-10;
    if (this.autoRowNumber<5){
      this.autoRowNumber = 5;
    }
    return this.autoRowNumber;
  }

  updateCASDFromUI(ie:InterfaceElement, key: any, attributeKey: string, attributeValue: any, casd: AsdBase){
    if(ie.TypeDID == InterfaceElementTypes.EntityList){
      let calledHeaderName = key;
      let casdIndex = casd.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(ie.InterfaceElementID);
      let ieHeaderItemIndex = ie.EntityList.HeaderItems.map(function(e){return e.Name}).indexOf(calledHeaderName);
      
      if(ieHeaderItemIndex > 0){
        ie.EntityList.HeaderItems[ieHeaderItemIndex].Attributes[attributeKey] = attributeValue;
      }
      
      if(casdIndex > -1){
        let headerItems : HeaderItem[]  = casd.InterfaceElements[casdIndex].EntityList.HeaderItems;
        let headerIndex = headerItems.map(function(e){return e.Name}).indexOf(calledHeaderName);
      
        
        if(headerIndex>-1){
          if(headerItems[headerIndex].Attributes == null) { headerItems[headerIndex].Attributes = new Attribute();}
          headerItems[headerIndex].Attributes[attributeKey] = attributeValue;
        }
        else if(headerIndex < 0){
          let headerItem = new HeaderItem();
          headerItem.Name = calledHeaderName;
          headerItem.Attributes = new Attribute();
          headerItem.Attributes[attributeKey] = attributeValue;
          headerItems.push(headerItem);
        }

      }
      else if(casdIndex < 0){
        let interfaceElement = new InterfaceElement();
        let headerItem = new HeaderItem();
        interfaceElement.InterfaceElementID = ie.InterfaceElementID;
        interfaceElement.EntityList = new IEEntityList();
        headerItem.Name = calledHeaderName;
        headerItem.Attributes = new Attribute();
        headerItem.Attributes[attributeKey] = attributeValue;
        interfaceElement.EntityList.HeaderItems = [];
        interfaceElement.EntityList.HeaderItems.push(headerItem);
        casd.InterfaceElements.push(interfaceElement);
      }

      
      this.cosyFormInitProperties.CustomAppStateDocument = casd;
           
      this.cosyCommunicationControllerService.postUpdatedCosyCustomDocument(
        this.cosyCommunicationControllerService.localSessionID,
        casd
      );


    }
  }

}
